<tds-header>
  <tds-header-title style="border-right: 1px solid var(--tds-header--basic-element-border);">
    <a routerLink="home" style="text-decoration: none;color: white;">CA - Credit Assessment</a>
  </tds-header-title>

  <!-- Solicitações -->
  <tds-header-item style="border-left: none;">
    <a routerLink="Solicitacoes">SOLICITAÇÕES</a>
  </tds-header-item>

  <!-- Cadastros -->
  <tds-header-dropdown style="border-left: none;">
    <span slot="label">CADASTROS</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/Bancos">Bancos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/DealersFrontOffices">Dealers e front-offices</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/Status">Status</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/Criticas">Críticas</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/Clientes">Clientes</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Cadastros/DealersGen">Dealers e Gen.</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <!-- Consultas -->
  <tds-header-dropdown style="border-left: none;">
    <span slot="label">CONSULTAS</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/ModFinanciamento">Modalidade Financiamento</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/Bancos">Bancos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/FrontOffices">Front Offices</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/SolicitacaoCritica">Solicitações em Crítica</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/ModeloProdutos">Modelos de Produtos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/Faturadas">Faturadas</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/Canceladas">Canceladas</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/Desistencia">Desistência</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/AutVencidas">Autorizações Vencidas</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/ListaCredito">Lista de Créditos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Consultas/FrontOfficeRequest">Solicitações para Fof ou Banco</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <!-- Relatórios -->
  <tds-header-dropdown style="border-left: none;">
    <span slot="label">RELATÓRIOS</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a href="http://reports.br.scania.com/ws/Pages/ReportViewer.aspx?%2fCA%2fPosicao_de_Credito&rs:Command=Render" target="_blank">Situações de Crédito</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <!-- Administração -->
  <tds-header-dropdown style="border-left: none;">
    <span slot="label">ADMINISTRAÇÃO</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a routerLink="Admin/Processamento">Processamento</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Admin/EmailsPadrao">E-mails Padrão</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Admin/MotivoFup">Motivo para Follow Up</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Admin/UploadArquivos">Upload de Arquivos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a routerLink="Admin/ProgramaBndes">Programas BNDES</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield" href="https://scania.com"></a>
  </tds-header-brand-symbol>
</tds-header>
<main class="content-container">
  <router-outlet />
</main>